// import React, { useState } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   CircularProgress,
//   Alert,
//   IconButton,
//   Paper,
//   Chip,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import CloseIcon from '@mui/icons-material/Close';
// import VisibilityIcon from '@mui/icons-material/Visibility';

// const ExcelViewerDialog = ({ 
//   open, 
//   onClose, 
//   data, 
//   loading, 
//   error, 
//   fileName 
// }) => {
//   const [jsonViewerOpen, setJsonViewerOpen] = useState(false);
//   const [selectedJsonData, setSelectedJsonData] = useState(null);
//   const [selectedJsonField, setSelectedJsonField] = useState('');

//   // Format header names to be more readable
//   const formatHeaderName = (key) => {
//     return key
//       .split('_')
//       .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
//       .join(' ');
//   };

//   const handleViewJson = (jsonData, fieldName) => {
//     setSelectedJsonData(jsonData);
//     setSelectedJsonField(fieldName);
//     setJsonViewerOpen(true);
//   };

//   const handleCloseJsonViewer = () => {
//     setJsonViewerOpen(false);
//     setSelectedJsonData(null);
//     setSelectedJsonField('');
//   };

//   // Transform data for DataGrid
//   const transformedData = React.useMemo(() => {
//     if (!data || !data.data || !Array.isArray(data.data) || data.data.length === 0) {
//       return { columns: [], rows: [] };
//     }

//     // Get all unique keys from all data objects to create columns
//     const allKeys = new Set();
//     data.data.forEach(item => {
//       Object.keys(item).forEach(key => allKeys.add(key));
//     });

//     // Create columns from all keys
//     const columns = Array.from(allKeys).map((key) => ({
//       field: key,
//       headerName: formatHeaderName(key),
//       width: 200,
//       flex: 1,
//       minWidth: 150,
//       sortable: true,
//       filterable: true,
//       renderCell: (params) => {
//         const value = params.value;
//         if (value === null || value === undefined || value === '') {
//           return <Typography variant="body2" color="text.secondary">-</Typography>;
//         }
        
//         // Handle JSON objects (including parsed content field)
//         if (typeof value === 'object' && value !== null) {
//           return (
//             <Button
//               size="small"
//               startIcon={<VisibilityIcon />}
//               onClick={() => handleViewJson(value, key)}
//               sx={{ 
//                 minWidth: 'auto',
//                 px: 1,
//                 py: 0.5,
//                 fontSize: '0.75rem'
//               }}
//             >
//               View
//             </Button>
//           );
//         }
        
//         // Handle numeric values with special formatting (but not for date-like strings)
//         if (typeof value === 'string' && (value.includes('T') || value.includes('-') || value.includes(':'))) {
//           // This looks like a date/timestamp, don't format as number
//           return (
//             <Typography variant="body2" sx={{ maxWidth: '100%' }}>
//               {String(value)}
//             </Typography>
//           );
//         }
        
//         const numericValue = parseFloat(value);
//         if (!isNaN(numericValue)) {
//           return (
//             <Typography 
//               variant="body2" 
//               sx={{ 
//                 fontFamily: 'monospace',
//                 color: numericValue < 0 ? 'error.main' : numericValue > 0 ? 'success.main' : 'text.primary',
//                 fontWeight: numericValue !== 0 ? 500 : 400,
//                 textAlign: 'right'
//               }}
//             >
//               {numericValue.toLocaleString()}
//             </Typography>
//           );
//         }
        
        
//         return (
//           <Typography variant="body2" sx={{ maxWidth: '100%' }}>
//             {String(value)}
//           </Typography>
//         );
//       }
//     }));

//     // Prepare grid data with unique IDs - each row is a complete data object
//     const rows = data.data.map((item, index) => ({ 
//       ...item, 
//       id: index + 1 
//     }));

//     return { columns, rows };
//   }, [data]);

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="xl"
//       fullWidth
//       PaperProps={{
//         sx: {
//           height: '90vh',
//           maxHeight: '90vh',
//           width: '95vw',
//           maxWidth: '95vw',
//         }
//       }}
//     >
//       <DialogTitle sx={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center',
//         pb: 1,
//         borderBottom: '1px solid #e0e0e0'
//       }}>
//         <Box>
//           <Typography variant="h6" component="div">
//             Excel File Viewer
//           </Typography>
//           {fileName && (
//             <Typography variant="body2" color="text.secondary">
//               {fileName}
//             </Typography>
//           )}
//         </Box>
//         <IconButton
//           onClick={onClose}
//           size="small"
//           sx={{ color: 'text.secondary' }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
//         {loading && (
//           <Box sx={{ 
//             display: 'flex', 
//             justifyContent: 'center', 
//             alignItems: 'center', 
//             height: '200px' 
//           }}>
//             <CircularProgress />
//             <Typography variant="body2" sx={{ ml: 2 }}>
//               Loading file data...
//             </Typography>
//           </Box>
//         )}

//         {error && (
//           <Box sx={{ p: 2 }}>
//             <Alert severity="error">
//               {error}
//             </Alert>
//           </Box>
//         )}

//         {!loading && !error && transformedData.rows.length > 0 && (
//           <Box sx={{ height: '100%', width: '100%' }}>
//             <DataGrid
//               rows={transformedData.rows}
//               columns={transformedData.columns}
//               pageSize={25}
//               rowsPerPageOptions={[10, 25, 50, 100]}
//               disableSelectionOnClick
//               sx={{
//                 border: 'none',
//                 '& .MuiDataGrid-cell': {
//                   borderBottom: '1px solid #f0f0f0',
//                 },
//                 '& .MuiDataGrid-columnHeaders': {
//                   backgroundColor: '#f5f5f5',
//                   borderBottom: '2px solid #e0e0e0',
//                 },
//                 '& .MuiDataGrid-row:hover': {
//                   backgroundColor: '#f9f9f9',
//                 },
//               }}
//             />
//           </Box>
//         )}

//         {!loading && !error && transformedData.rows.length === 0 && (
//           <Box sx={{ 
//             display: 'flex', 
//             justifyContent: 'center', 
//             alignItems: 'center', 
//             height: '200px' 
//           }}>
//             <Typography variant="body1" color="text.secondary">
//               No data available to display
//             </Typography>
//           </Box>
//         )}
//       </DialogContent>


//       {/* JSON Viewer Dialog */}
//       <Dialog
//         open={jsonViewerOpen}
//         onClose={handleCloseJsonViewer}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: {
//             height: '80vh',
//             maxHeight: '80vh',
//           }
//         }}
//       >
//         <DialogTitle sx={{ 
//           display: 'flex', 
//           justifyContent: 'space-between', 
//           alignItems: 'center',
//           pb: 1,
//           borderBottom: '1px solid #e0e0e0'
//         }}>
//           <Typography variant="h6" component="div">
//             JSON Viewer - {selectedJsonField}
//           </Typography>
//           <IconButton
//             onClick={handleCloseJsonViewer}
//             size="small"
//             sx={{ color: 'text.secondary' }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
//           <Box sx={{ 
//             p: 2, 
//             height: '100%', 
//             overflow: 'auto',
//             backgroundColor: '#f5f5f5'
//           }}>
//             <Paper sx={{ p: 2, backgroundColor: '#fff' }}>
//               <pre style={{ 
//                 margin: 0, 
//                 fontSize: '12px', 
//                 fontFamily: 'monospace',
//                 whiteSpace: 'pre-wrap',
//                 wordBreak: 'break-word'
//               }}>
//                 {JSON.stringify(selectedJsonData, null, 2)}
//               </pre>
//             </Paper>
//           </Box>
//         </DialogContent>

//       </Dialog>
//     </Dialog>
//   );
// };

// export default ExcelViewerDialog;

import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Alert,
  IconButton,
  Paper,
  Chip,
} from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { harmonateTokens as ht } from '../../../theme/harmonateTokens';
import {
  harmonateDialogPaperProps,
  harmonateDialogTitleSx,
  harmonateDialogContentSx,
  harmonateDialogCloseIconSx,
  harmonateDataGridSx,
  harmonateCardSx,
  harmonateAccentLinkSx,
} from '../../../theme/harmonateStyles';

/** `parseFloat("12/31/2024")` is 12 — only treat values as numbers when the whole cell is a plain decimal. */
const isGridNumericCellValue = (value) => {
  if (typeof value === 'number') return Number.isFinite(value);
  if (typeof value !== 'string') return false;
  const t = value.trim();
  if (t === '') return false;
  return /^-?\d+(\.\d+)?$/.test(t);
};

const parseGridNumericCellValue = (value) =>
  typeof value === 'number' ? value : parseFloat(String(value).trim());

const formatGridNumericDisplayText = (value, numericValue) => {
  if (typeof value === 'string' && isGridNumericCellValue(value)) return value.trim();
  return Number.isFinite(numericValue) ? numericValue.toString() : '';
};

const ExcelViewerDialog = ({ 
  open, 
  onClose, 
  data, 
  loading, 
  error, 
  fileName 
}) => {
  const [jsonViewerOpen, setJsonViewerOpen] = useState(false);
  const [selectedJsonData, setSelectedJsonData] = useState(null);
  const [selectedJsonField, setSelectedJsonField] = useState('');

  // Format header names to be more readable
  const formatHeaderName = (key) => {
    return key
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const handleViewJson = (jsonData, fieldName) => {
    setSelectedJsonData(jsonData);
    setSelectedJsonField(fieldName);
    setJsonViewerOpen(true);
  };

  const handleCloseJsonViewer = () => {
    setJsonViewerOpen(false);
    setSelectedJsonData(null);
    setSelectedJsonField('');
  };

  // Transform data for DataGrid
  const transformedData = React.useMemo(() => {
    if (!data || !data.data || !Array.isArray(data.data) || data.data.length === 0) {
      return { columns: [], rows: [] };
    }

    // Get all unique keys from all data objects to create columns
    const allKeys = new Set();
    data.data.forEach(item => {
      Object.keys(item).forEach(key => allKeys.add(key));
    });

    // Create columns from all keys
    const columns = Array.from(allKeys).map((key) => {
      let colWidth = 180;
      if (key.toLowerCase().includes('name')) colWidth = 220;
      if (key.toLowerCase().includes('content')) colWidth = 250;

      return {
        field: key,
        headerName: formatHeaderName(key),
        width: colWidth,
        sortable: true,
        filterable: true,
        renderCell: (params) => {
          const value = params.value;
          if (value === null || value === undefined || value === '') {
            return <Typography variant="body2" color="text.secondary">-</Typography>;
          }
          
          // Handle JSON objects
          if (typeof value === 'object' && value !== null) {
            return (
              <Button
                size="small"
                startIcon={<VisibilityIcon />}
                onClick={() => handleViewJson(value, key)}
                sx={{ 
                  ...harmonateAccentLinkSx,
                  minWidth: 'auto',
                  px: 1,
                  py: 0.5,
                  fontSize: '0.75rem'
                }}
              >
                View
              </Button>
            );
          }
          
          if (isGridNumericCellValue(value)) {
            const numericValue = parseGridNumericCellValue(value);
            const displayText = formatGridNumericDisplayText(value, numericValue);
            return (
              <Typography 
                variant="body2" 
                sx={{ 
                  fontFamily: 'monospace',
                  color: numericValue < 0 ? ht.red : numericValue > 0 ? ht.green : ht.text,
                  fontWeight: numericValue !== 0 ? 500 : 400,
                  textAlign: 'right'
                }}
              >
                {displayText}
              </Typography>
            );
          }

          if (
            typeof value === 'string' &&
            (value.includes('T') || (value.includes('-') && value.includes(':')) || /^\d{4}-\d{2}-\d{2}/.test(value.trim()))
          ) {
            return (
              <Typography variant="body2" sx={{ maxWidth: '100%' }}>
                {String(value)}
              </Typography>
            );
          }
          
          return (
            <Typography variant="body2" sx={{ maxWidth: '100%' }}>
              {String(value)}
            </Typography>
          );
        }
      };
    });

    // Prepare grid data with unique IDs
    const rows = data.data.map((item, index) => ({ 
      ...item, 
      id: index + 1 
    }));

    return { columns, rows };
  }, [data]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          ...harmonateDialogPaperProps.sx,
          height: '90vh',
          maxHeight: '90vh',
          width: '98vw',
          maxWidth: '98vw',
        }
      }}
    >
      <DialogTitle sx={harmonateDialogTitleSx}>
        <Box>
          <Typography variant="h6" component="div" sx={{ color: ht.white, fontWeight: 700 }}>
            Excel File Viewer
          </Typography>
          {fileName && (
            <Typography variant="body2" sx={{ color: ht.white }}>
              {fileName}
            </Typography>
          )}
        </Box>
        <IconButton
          onClick={onClose}
          size="small"
          sx={harmonateDialogCloseIconSx}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ ...harmonateDialogContentSx, p: 2, overflow: 'hidden' }}>
        {loading && (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '200px' 
          }}>
            <CircularProgress sx={{ color: ht.blue }} />
            <Typography variant="body2" sx={{ ml: 2 }}>
              Loading file data...
            </Typography>
          </Box>
        )}

        {error && (
          <Box sx={{ p: 2 }}>
            <Alert severity="error">
              {error}
            </Alert>
          </Box>
        )}

        {!loading && !error && transformedData.rows.length > 0 && (
          <Box sx={{ height: '75vh', width: '100%', overflowX: 'auto' }}>
            <DataGridPro
              columnResizeMode="onEnd"
              resizable
              rows={transformedData.rows}
              columns={transformedData.columns}
              pageSize={25}
              rowsPerPageOptions={[10, 25, 50, 100]}
              disableSelectionOnClick
              autoHeight={false}
              sx={{
                ...harmonateDataGridSx,
                minWidth: '1200px',
                '& .MuiDataGrid-cell': {
                  ...harmonateDataGridSx['& .MuiDataGrid-cell'],
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              }}
            />
          </Box>
        )}

        {!loading && !error && transformedData.rows.length === 0 && (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '200px' 
          }}>
            <Typography variant="body1" color="text.secondary">
              No data available to display
            </Typography>
          </Box>
        )}
      </DialogContent>

      {/* JSON Viewer Dialog */}
      <Dialog
        open={jsonViewerOpen}
        onClose={handleCloseJsonViewer}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            ...harmonateDialogPaperProps.sx,
            height: '80vh',
            maxHeight: '80vh',
          }
        }}
      >
        <DialogTitle sx={harmonateDialogTitleSx}>
          <Typography variant="h6" component="div" sx={{ color: ht.white, fontWeight: 700 }}>
            JSON Viewer - {selectedJsonField}
          </Typography>
          <IconButton
            onClick={handleCloseJsonViewer}
            size="small"
            sx={harmonateDialogCloseIconSx}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
          <Box sx={{ 
            p: 2, 
            height: '100%', 
            overflow: 'auto',
            backgroundColor: ht.listBg
          }}>
            <Paper sx={{ ...harmonateCardSx, p: 2, bgcolor: ht.white }}>
              <pre style={{ 
                margin: 0, 
                fontSize: '12px', 
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
              }}>
                {JSON.stringify(selectedJsonData, null, 2)}
              </pre>
            </Paper>
          </Box>
        </DialogContent>
      </Dialog>
    </Dialog>
  );
};

export default ExcelViewerDialog;

